import Styles from './NavPage.module.scss'
import { useNavigate } from 'react-router-dom';
import { Notification } from 'components/notifications/notification';
import { NavCard } from './NavCard';
import FeatherIcon from 'feather-icons-react';

export function NavPage(props) {

    const navDetails = [
        {
            icon: <FeatherIcon icon="monitor" />,
            title: "global.products.labs",
            description: "global.descriptions.labs",
            backgroundColor: "#FFECEC",
            iconColor: "#facbcb",
            path: "/labs"
        },
        {
            icon: <FeatherIcon icon="code" />,
            title: "global.products.streams",
            description: "global.descriptions.streams",
            backgroundColor: "#F0F6FF",
            iconColor: "#caddfd",
            path: "/streams/all"
        },
        {
            icon: <FeatherIcon icon="award" />,
            title: "global.products.lpaths",
            description: "global.descriptions.lpaths",
            backgroundColor: "#EFFFF4",
            iconColor: "#bfe6ce",
            path: "/lpaths"
        },
        {
            icon: <FeatherIcon icon="help-circle" />,
            title: "global.products.quiz",
            description: "global.descriptions.quiz",
            backgroundColor: "#FFFBEF",
            iconColor: "#f7f1d1",
            path: "/quiz"
        },
        {
            icon: <FeatherIcon icon="folder" />,
            title: "global.products.project",
            description: "global.descriptions.project",
            backgroundColor: "#FFF0F6",
            iconColor: "#f9d3e0",
            path: "/projects"
        },
        {
            icon: <FeatherIcon icon="user" />,
            title: "global.products.interview",
            description: "global.descriptions.interview",
            backgroundColor: "#FDE5FD",
            iconColor: "#EFB6FF",
            path: "/interview/topics"
        },
        {
            icon: <FeatherIcon icon="package" />,
            title: "global.products.internship",
            description: "global.descriptions.internship",
            backgroundColor: "#D5FFFD",
            iconColor: "#9DFFFA",
            path: "/internships"
        },
    ]
    const navigate = useNavigate()
    return (
        <>
            <div className={`${Styles.superAncestor}`}>
                <Notification
                    call='all'
                />
                <div className={Styles.gridContainer}>
                    {navDetails.map((item, index) => (
                        <NavCard t={props.t} key={index} item={item} onClick={() => navigate(item.path)} />
                    ))}
                </div>

            </div>
        </>
    )

}
